import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
export default class ToolsPage extends Page {
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle('Free OFW Tools');
  }
  view() {
    const tools = [{
      title: 'EOSB Calculator',
      description: 'Estimate your end-of-service benefits based on your salary and years of service.',
      url: '/p/4-eosb-calculator',
      icon: 'fas fa-calculator'
    }, {
      title: 'Notice Period Calculator',
      description: 'Calculate important notice-period dates for your employment contract.',
      url: '/p/15-notice-period-calculator',
      icon: 'fas fa-calendar-days'
    }, {
      title: 'Saudi Overtime Checker',
      description: 'Estimate your overtime pay based on the current Saudi Labor Law Article 107 computation.',
      url: 'https://pinoytalks.com/p/17-saudi-overtime-calculator',
      icon: 'fas fa-clock'
    }, {
      title: 'Leave Pay Checker',
      description: 'Estimate the value of your unused annual leave based on your wage and unused leave days.',
      url: '/pages/leave-pay-checker',
      icon: 'fas fa-umbrella-beach'
    }, {
      title: 'PESO Converter',
      description: 'Check exchange rates and convert Saudi Riyal, Philippine Peso and other currencies.',
      url: '/p/10-exchange-rate-today',
      icon: 'fas fa-peso-sign'
    }, {
      title: 'Letter / Request Maker',
      description: 'Create practical workplace letters and requests for common OFW situations.',
      url: '/p/7-letter-builder',
      icon: 'fas fa-paper-plane'
    }, {
      title: 'CV / Resume Builder',
      description: 'Create a professional resume to help you prepare for your next job opportunity.',
      url: '/p/5-resume-builder',
      icon: 'fas fa-file-lines'
    }];
    return m("div", {
      className: "PinoyTalksToolsPage"
    }, m("div", {
      className: "container"
    }, m("section", {
      className: "PinoyTalksToolsHero"
    }, m("span", {
      className: "PinoyTalksToolsEyebrow"
    }, "PINOYTALKS OFW TOOLS"), m("h1", null, "Free Practical Tools for Filipino OFWs"), m("p", null, "Useful calculators, builders and resources designed to make everyday OFW tasks easier.")), m("div", {
      className: "PinoyTalksToolsGrid"
    }, tools.map(tool => m(Link, {
      href: tool.url,
      className: "PinoyTalksToolCard",
      key: tool.title
    }, m("div", {
      className: "PinoyTalksToolCardIcon"
    }, m("i", {
      className: tool.icon,
      "aria-hidden": "true"
    })), m("div", {
      className: "PinoyTalksToolCardContent"
    }, m("h2", null, tool.title), m("p", null, tool.description), m("span", {
      className: "PinoyTalksToolCardAction"
    }, "Open Tool", m("i", {
      className: "fas fa-arrow-right",
      "aria-hidden": "true"
    }))))))));
  }
}
flarum.reg.add('pinoytalks-blog', 'forum/components/ToolsPage', ToolsPage);